const multimediaCanPauseModes = {
    BASIC: 'basic',
    MODERATE: 'moderate',
    STRICT: 'strict',
};

export default multimediaCanPauseModes;
